import React, { Component } from 'react';
import { drizzleConnect } from 'drizzle-react';
import PropTypes from 'prop-types';
import Spinner from './Spinner';
import OwnedList from './OwnedList';

class AliasInfo extends Component {
  constructor(props, context) {
    super(props);
    this.contract = context.drizzle.contracts.Alias;
    this.store = context.drizzle.store;
    this.methods = this.contract.methods;
    this.web3Util = context.drizzle.web3.utils;

    this.handleChange = this.handleChange.bind(this);
    this.handleGetAddress = this.submissionWrapper(this.handleGetAddress.bind(this));
    this.setAlias = this.submissionWrapper(this.setAlias.bind(this));

    const { location } = this.props;
    this.defaultState = {
      alias: location.pathname === '/set' ? location.query.shortcut : '',
      message: '',
      isPerformingAction: false,
      error: '',
      mapped: {},
      owned: null,
      accounts: Object.keys(this.props.accounts).map(idx => this.props.accounts[idx])
    };
    this.state = this.defaultState;
  }

  componentDidMount() {
    this.getAllContractsByAddress();
  }

  handleChange(event) {
    this.setState({[event.target.name]: event.target.value});
  }

  getAllContracts() {
    return this.methods.getCount().call().then(count => {
        const promises = [];
        for (let i = 0; i < count; i++) {
            promises.push(this.methods.names(i).call());
        }
        return Promise.all(promises).then(result =>
          result.map(item => this.web3Util.toAscii(item))
        );
    });
  }

  getPrice(alias) {
    const bytes = this.web3Util.fromAscii(alias);
    return this.methods.getPrice(bytes).call();
  }

  getAllContractsByAddress() {
    const mappedContracts = {};
    return this.getAllContracts().then(names => {
        const mappingBuilder = names.map(alias => {
            return Promise.all([
                this.getAddressForAlias(alias),
                this.getPrice(alias)
            ]).then(([address, price]) => {
                if (!mappedContracts[address]) mappedContracts[address] = [];
                mappedContracts[address].push({alias, price: this.web3Util.fromWei(price)});
            });
        });
        if (mappingBuilder.length) {
            return Promise.all(mappingBuilder).then(() => {
                const ownedAliases = this.state.accounts.reduce((owned, acc) => {
                    return owned.concat(mappedContracts[acc]);
                }, []);
                this.setState({
                  owned: ownedAliases,
                  mapped: mappedContracts,
                  isPerformingAction: false
                });
            });
        } else {
          this.setState({isPerformingAction: false});
        }

    });
  }

  submissionWrapper(fn) {
    return () => {
      this.setState({ isPerformingAction: false, error: '' });
      const alias = this.state.alias;
      if (alias) fn(alias);
    };
  }

  getAddressForAlias(alias) {
    this.setState({ isPerformingAction: true });
    const bytes = this.web3Util.fromAscii(alias);
    return this.methods.get(bytes).call();
  }

  handleGetAddress(alias) {
    this.getAddressForAlias(alias).then(address => {
      const isValidAddress = Number(address) !== 0;
      this.setState({
        isPerformingAction: false,
        message: isValidAddress ? `Address: ${address}` : 'Address Not Found'
      });
    });
  }

  doesAliasExist(alias) {
    return this.getAddressForAlias(alias).then(address => {
      return Number(address) !== 0;
    });
  }

  setAlias(alias) {
    this.doesAliasExist(alias).then(exists => {

      if (exists) {
        this.setState({
          isPerformingAction: false,
          error: 'Alias already exists'
        });
      } else {
        return this.getPrice(alias).then(price => {
          const bytes = this.web3Util.fromAscii(alias);
          this.methods.buy.cacheSend(bytes, {value: price});
          this.setState({
            isPerformingAction: false,
            message: 'Your shiny new Ether DNS will be ready shortly after transaction is confirmed'
          });
        });
      }
    });
  }

  getTransactionStatus(txHash) {
    const state = this.store.getState();
    return state.transactions(txHash).status;
  }

  postAliasForSale(alias, price) {
    const bytes = this.web3Util.fromAscii(alias);
    return this.methods.putForSale.cacheSend(bytes, price);
  }

  getRoute() {
    const path = this.props.route.path.toLowerCase();
    switch (path) {
      case '/set': return 'set';
      case '/find': return 'find';
      default: return 'home';
    }
  }

  getText() {
    switch (this.getRoute()) {
      case 'set':
        return {
          title: 'Set a New Ether DNS',
          body: `Want to set an Ether DNS for your account? <br> Go right ahead! Pick a name of your choosing.`
        };
      case 'find':
        return {
          title: 'Find an Ether DNS',
          body: `Looking for an address? <br> Type the etherdns entry.`
        };
      default: return null;
    }
  }

  renderButton() {
    switch (this.getRoute()) {
      case 'set':
        return <button className="fill teal" onClick={this.setAlias}>Set Alias</button>;
      case 'find':
        return <button className="up" onClick={this.handleGetAddress}>Get Address</button>;
      default: return null;
    }
  }

  render() {
    const text = this.getText();
    return (
      <div className="alias-info">
        <div className="title-body">
          <div className="title" dangerouslySetInnerHTML={{ __html: text.title }}></div>
          <div className="body" dangerouslySetInnerHTML={{ __html: text.body }}></div>
        </div>
        <div className="alias-form">
          <input
            name='alias'
            onChange={this.handleChange}
            value={this.state.alias}
          />
          {this.renderButton()}
        </div>
        <div className="info-container">
          <span className="result">
            {!this.state.isPerformingAction && !this.state.error && this.state.message
              ? <div>{this.state.message}</div>
              : null
            }
          </span>
          {this.state.isPerformingAction ? <Spinner /> : null}
          <span className="error">
            {this.state.error ? <div>{this.state.error}</div> : null}
          </span>
        </div>
        <div>
        <OwnedList list={this.state.owned} />
        </div>
      </div>
    );
  }
}

AliasInfo.contextTypes = {
  drizzle: PropTypes.object,
  contracts: PropTypes.object,
};

const mapStateToProps = state => {
  return {
    accounts: state.accounts,
    contracts: state.contracts,
    drizzleStatus: state.drizzleStatus,
    transactions: state.transactionStack
  }
};

export default drizzleConnect(AliasInfo, mapStateToProps);



// WEBPACK FOOTER //
// ./src/components/AliasInfo.js